import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// English namespaces
import enCommon from './locales/en/common.json';
import enLanding from './locales/en/landing.json';
import enAbout from './locales/en/about.json';
import enAAW from './locales/en/aaw.json';
import enCAE from './locales/en/cae.json';
import enGAE from './locales/en/gae.json';
import enHub from './locales/en/hub.json';
import enHubVdl from './locales/en/hubvdl.json';
import enVM from './locales/en/vm.json';
import enVmVdl from './locales/en/vmvdl.json';
import enDialogs from './locales/en/dialogs.json';
import enPricing from './locales/en/pricing.json';
import enFAQ from './locales/en/faq.json';
import enTermsAndConditions from './locales/en/termsAndConditions.json';

// French namespaces
import frCommon from './locales/fr/common.json';
import frLanding from './locales/fr/landing.json';
import frAbout from './locales/fr/about.json';
import frAAW from './locales/fr/aaw.json';
import frCAE from './locales/fr/cae.json';
import frGAE from './locales/fr/gae.json';
import frHub from './locales/fr/hub.json';
import frHubVdl from './locales/fr/hubvdl.json';
import frVM from './locales/fr/vm.json';
import frVmVdl from './locales/fr/vmvdl.json';
import frDialogs from './locales/fr/dialogs.json';
import frPricing from './locales/fr/pricing.json';
import frFAQ from './locales/fr/faq.json';
import frTermsAndConditions from './locales/fr/termsAndConditions.json';

const resources = {
  en: {
    common: enCommon,
    landing: enLanding,
    about: enAbout,
    aaw: enAAW,
    cae: enCAE,
    gae: enGAE,
    hub: enHub,
    hubvdl: enHubVdl,
    vm: enVM,
    vmvdl: enVmVdl,
    dialogs: enDialogs,
    pricing: enPricing,
    faq: enFAQ,
    termsAndConditions: enTermsAndConditions,
  },
  fr: {
    common: frCommon,
    landing: frLanding,
    about: frAbout,
    aaw: frAAW,
    cae: frCAE,
    gae: frGAE,
    hub: frHub,
    hubvdl: frHubVdl,
    vm: frVM,
    vmvdl: frVmVdl,
    dialogs: frDialogs,
    pricing: frPricing,
    faq: frFAQ,
    termsAndConditions: frTermsAndConditions,
  },
};

const LanguageDetector = {
  type: 'languageDetector',
  detect() {
    return window.location.pathname.includes('/services-analyse-donnees')
      ? 'fr'
      : 'en';
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: [
      'common',
      'landing',
      'about',
      'aaw',
      'cae',
      'gae',
      'hub',
      'hubvdl',
      'vm',
      'vmvdl',
      'dialogs',
      'pricing',
      'faq',
      'termsAndConditions',
    ],
    defaultNS: 'common',
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: ['en', 'fr'],
  });

export default i18n;
